import React, { useEffect, useState } from "react";
import Input from "../../../Components/Input/Input";
import {
  fetchCountryList,
  getSuggestList,
  getViewAirport,
  updateAirport,
} from "../../../utils/api";
import { useParams } from "react-router-dom";
import { useDebounce } from "../../../Components/hooks/useDebounce";
import { isEmpty } from "../../../utils/common";
import { AlertWrapper } from "../../../assets/styles/AlerWrapper";
import AutoSuggestion from "../../../Components/AutoSuggest/AutoSuggest";

const ViewAirportDetails = () => {
  const { id } = useParams();
  const [viewHotelData, setViewHotelData] = useState({});
  const [countryList, setCountryList] = useState([]);
  const [filteredCountries, setFilteredCountries] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
   const [showSuggestions, setShowSuggestions] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
  

  const debounceValue = useDebounce(viewHotelData?.country, 500);

  useEffect(() => {
    fetchCountryList()
      .then((response) => {
        setCountryList(response?.data?.data?.countries || []);
      })
      .catch((error) => {
        console.error("Failed to fetch country list:", error);
      });
  }, []);

  useEffect(() => {
    const filtered = countryList.filter((country) => (country?.name || "").toLowerCase().includes((debounceValue || "").toLowerCase()));
    setFilteredCountries(filtered || [])
  }, [debounceValue, countryList]);

  
  
  
  const viewHotel = () => {
    getViewAirport(id).then((response) => {
      setViewHotelData(response?.data?.data || {});
    });
  };

  useEffect(() => {
    viewHotel();
  }, []);

  const validateFields = () => {
    let isValid = true;
    const newErrors = {};

    if (!viewHotelData.name || viewHotelData.name.trim() === "") {
      newErrors.name = "Name is required.";
      isValid = false;
    }
    if (!viewHotelData.code || viewHotelData.code.trim() === "") {
      newErrors.code = "Code is required.";
      isValid = false;
    }
    if (viewHotelData.active === undefined || viewHotelData.active === "") {
      newErrors.active = "Status is required.";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleUpdate = () => {
    if (validateFields()) {
      const param = {  id, sd:"fdsf" , ...viewHotelData };
      updateAirport(param)
        .then(() => {
          setMessage({type:"success",message:"Airport updated successfully!"});
        })
        .catch(() => {
          setMessage({type:"Error",message:"Airport Not updated successfully!"});
        });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setViewHotelData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const fetchSuggestions = (query, identifier,type) => {
          getSuggestList(query, identifier,type)
            .then((resp) => {
              console.log("API Response:", resp?.data.data.suggestions); // Debug response
              if (resp?.data.data.suggestions) {
                setSuggestions([...resp?.data.data.suggestions]);
               // setShowSuggestions(true);
               
              } else {
                setSuggestions([]);
                setShowSuggestions(false); // Handle no suggestions case
                
              }
            })
            .catch((error) => console.error("Error fetching suggestions:", error));
        };
  
        const debounceValuecity = useDebounce(viewHotelData?.city, 500);
  
       useEffect(() =>{
          fetchSuggestions(debounceValuecity, "loc","1");
           },[debounceValuecity])

  const handleCountrySelect = (country) => {
    setViewHotelData((prevData) => ({
      ...prevData,
      country: country.name,
      countryCode: country.iso2,
    }));
    setIsOpen(false)
    setFilteredCountries([]);
  };
  
  useEffect(() =>{
     if( isEmpty(message)) return;
    
     setTimeout(() =>{
      setMessage({})
     },5000)
    
      },[message])

  console.log("filteredCountries",filteredCountries);

  return (

    
    <div style={{ padding: "30px" }}>
       {!isEmpty(message) && (
                    <AlertWrapper className={`${message.type} globle`}>
                      <span className="close" onClick={() => setMessage({})}>
                        ×
                      </span>
                      {message.message}
                    </AlertWrapper>
                  )}
      <div className="subadmin_container column flex gap-50">
        <div style={{ padding: "30px", flex: "1 1 100%" }}>
         
        <div style={{flex:"1 1 50%"}}>
                  
                  
                  <div className="labelname mb-5">
                    <label className="fw-bold">City Name:</label>
                  </div>

                 
                  <Input
                    type="text"
                 
                    placeholder="City Name"
                    name="city"
                    value={viewHotelData?.city || ""}
                    onChange={handleInputChange}
                    onFocus={() =>setShowSuggestions(true)}
                  />
                   { showSuggestions && suggestions.length > 0 && (
     <div style={{position:"absolute"}}>
       <AutoSuggestion
    fromCityList={suggestions}
     //className="hotelCityName"
 
    setCityName={(name) =>
      setViewHotelData((prev) => ({
        ...prev,
        city: name,
      }))
    }
    setCityId={(id) =>
      setViewHotelData((prev) => ({
        ...prev,
        cityId: id, // Set the selected city ID
      }))
    }
   
    setShowCity={setShowSuggestions}
    showCity={{ fromCityShow: true }}
    cityNameKey="cityName"
    inputElement={null}
  />

     </div>
                  )}

             
                </div>

          <div className="flex gap-10 mt-20" style={{ flex: "1 1 50%" }}>
            <div style={{ flex: "1 1 50%" }}>
              <div className="labelname mb-5">
                <label className="fw-bold">Name:</label>
              </div>
              <Input
                type="text"
                placeholder="Name"
                name="name"
                value={viewHotelData?.name || ""}
                onChange={handleInputChange}
              />
              {errors.name && (
                <p className="error fs-12 mt-10">{errors.name}</p>
              )}
            </div>
            <div style={{ flex: "1 1 50%" }}>
              <div className="labelname mb-5">
                <label className="fw-bold">Code:</label>
              </div>
              <Input
                type="text"
                placeholder="Code"
                name="code"
                value={viewHotelData?.code || ""}
                onChange={handleInputChange}
              />
              {errors.code && (
                <p className="error fs-12 mt-10">{errors.code}</p>
              )}
            </div>
          </div>

          <div className="flex gap-10 mt-20" style={{ flex: "1 1 50%" }}>
            <div style={{ flex: "1 1 50%"}}>
              <div className="labelname mb-5">
                <label className="fw-bold">Country:</label>
              </div>
              <Input
                type="text"
                placeholder="Country"
                name="country"
                value={viewHotelData?.country || ""}
                onChange={handleInputChange}
                onFocus={()=>setIsOpen(true)}
              />
              {filteredCountries.length > 0 && isOpen && (
                <div className="dropdown mt-10" style={{maxWidth:"330px",width:"100%"}}>
                  {filteredCountries.map((country) => (
                    <div
                      key={country.iso2}
                      className="dropdown-item fs-14"
                      style={{paddingBottom:"5px",borderBottom:"1px solid #8080803d",paddingTop:"5px"}}
                      onClick={() => handleCountrySelect(country)}
                    >
                      {country.name} ({country.iso2})
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="flex gap-10" style={{ flex: "1 1 50%" }}>
            <div className="input-field">
              <div className="labelname mb-5">
                <label className="fw-bold">Status:</label>
              </div>
              <select
                style={{ width: "330px" }}
                className="input_select_field"
                name="active"
                value={viewHotelData?.active || ""}
                onChange={handleInputChange}
              >
                <option value="">Select Status:</option>
                <option value={true}>ACTIVE</option>
                <option value={false}>INACTIVE</option>
              </select>
              {errors.active && (
                <p className="error fs-12 mt-10">{errors.active}</p>
              )}
            </div>
          </div>

          </div>
          <div className="flex gap-10 mt-20">
            <div style={{ flex: "1 1 50%" }}>
              <label className="fw-bold">North East Latitude:</label>
              <Input
                type="text"
                placeholder="North East Latitude"
                name="northEastLatitude"
                value={viewHotelData?.northEastLatitude?.toString() || ""}
                onChange={handleInputChange}
              />
            </div>
            <div style={{ flex: "1 1 50%" }}>
              <label className="fw-bold">North East Longitude:</label>
              <Input
                type="text"
                placeholder="North East Longitude"
                name="northEastLongitude"
                value={viewHotelData?.northEastLongitude?.toString() || ""}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="flex gap-10 mt-20">
            <div style={{ flex: "1 1 50%" }}>
              <label className="fw-bold">South West Latitude:</label>
              <Input
                type="text"
                placeholder="South West Latitude"
                name="southWestLatitude"
                value={viewHotelData?.southWestLatitude?.toString() || ""}
                onChange={handleInputChange}
              />
            </div>
            <div style={{ flex: "1 1 50%" }}>
              <label className="fw-bold">South West Longitude:</label>
              <Input
                type="text"
                placeholder="South West Longitude"
                name="southWestLongitude"
                value={viewHotelData?.southWestLongitude?.toString() || ""}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <div className="mt-20">
            <button onClick={handleUpdate} className="userlist_btn">
              Update Airport
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewAirportDetails;
